/* eslint-disable no-unreachable */
// @flow
import { takeEvery, put, call } from 'redux-saga/effects';
import { getResource } from '@redux/components/ApiRequest/actions';
import { pageReady } from '@redux/components/Page/actions';
import { packageApiUrl } from '@lib';
import { PACKAGE_DETAILS_REQUEST, PACKAGE_DETAILS_REQUESTED_SUCCESS } from './constants';
import { successRequestPackageDetails, errorRequestPackageDetails } from './actions';

import type { Action } from '../types';

export function* packageDetailsRequestFlow({ slug }: Action): Generator<Function, void, void> {
  if (!slug) return;

  const url: string = `${packageApiUrl}/v1/treatment_packages/${slug}`;

  yield put(getResource(url, successRequestPackageDetails, errorRequestPackageDetails));
}

export function* packageDetailsSuccessFlow(): Generator<Function, void, void> {
  yield put(pageReady());
}

export function* packageDetailsFlow(action: Action): Generator<Function, void, void> {
  switch (action.type) {
    case PACKAGE_DETAILS_REQUEST:
      yield call(packageDetailsRequestFlow, action);
      break;
    case PACKAGE_DETAILS_REQUESTED_SUCCESS:
      yield call(packageDetailsSuccessFlow, action);
      break;
    default:
      break;
  }
}
export default function* packageDetailsWatcher(): Generator<Function, void, Action> {
  yield takeEvery([PACKAGE_DETAILS_REQUEST, PACKAGE_DETAILS_REQUESTED_SUCCESS], packageDetailsFlow);
}
